import { ChangeDetectorRef, Component, Injector, Input, OnInit } from "@angular/core";
import { finalize } from "@node_modules/rxjs/operators";
import { AppComponentBase } from "@shared/app-component-base";
import { ConsultaDto, ConsultaServiceProxy, TipoUsuarioEnum, UpdateConsultaDto, UpdateObservacaoDto } from "@shared/service-proxies/service-proxies";
import * as moment from "moment";
import { Router } from '@angular/router';


@Component({
    selector: 'card-consulta',
    templateUrl: './card-consulta.component.html',
    styleUrls: ['./card-consulta.component.scss'],
})
export class CardConsultaComponent extends AppComponentBase implements OnInit {
    @Input() consulta: ConsultaDto;
    @Input() isHome: boolean = false;

    horaInicio!: string;
    horaFim!: string;
    protected novaObservacaoPaciente: string = "";
    protected novaObservacaoProfissional: string = "";
    protected expanded: boolean = false;
    protected isProfissional: boolean = false;

    constructor(
        injector: Injector,
        private readonly _consultaService: ConsultaServiceProxy,
        private _cdr: ChangeDetectorRef,
        private _router: Router
    ) {
        super(injector)
    }


    ngOnInit(): void {

        const currentUrl = this._router.url;

        this.isProfissional = currentUrl.includes('profissional-saude');

        if (this.consulta) {
            const inicio = moment(this.consulta.dataConsulta);
            const fim = inicio.clone().add(30, 'minutes');

            this.horaInicio = inicio.format('HH:mm');
            this.horaFim = fim.format('HH:mm');
            this.novaObservacaoPaciente = this.consulta.observacaoPaciente;
            this.novaObservacaoProfissional = this.consulta.observacaoProfissional;
        }
    }


    protected getConsulta(): void {
        abp.ui.setBusy();
        this._consultaService.get(this.consulta.id).pipe(
            finalize(() => {
                abp.ui.clearBusy();
            })
        ).subscribe((result) => {
            this.consulta = result;
            this._cdr.markForCheck();
        });
    }

    protected toggleExpand(): void {
        this.expanded = !this.expanded;
        this._cdr.detectChanges();
    }

    protected atualizarObservacoes(isProfissional: boolean): void {
        let dto = new UpdateObservacaoDto();
        dto.consultaId = this.consulta.id;
        dto.observacaoPaciente = isProfissional ? "" : this.novaObservacaoPaciente
        dto.observacaoProfissional = isProfissional ? this.novaObservacaoProfissional : "";
        this._consultaService.editarObservacao(dto).subscribe(() => {
            abp.notify.info("Observação atualizada com sucesso!");
        });
    }
}
